<template>
    <Head :title="pageTabLabel" />
    <BaseLayout gap="lg">
        <MomentsWithConnections
            v-if="moments_with_connections_enabled"
            :moments="performance_review_moments.moments ?? []"
            :organization-cards="organization_cards"
            :show-nadia-teams-eval-notification="showNadiaTeamsEvalNotification"
            :has-people-to-review="has_people_to_review" />
        <Moments v-else :moments="performance_review_moments.moments ?? []" :organization-cards="organization_cards" />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
import type { OrganizationCard } from "~vue/types/chat_home";
import type { PerformanceReviewMoments } from "~vue/types/performance_management";
export default { layout: LeftSidebarLayout };

interface Props {
    performance_review_moments?: PerformanceReviewMoments;
    organization_cards?: OrganizationCard[];
    moments_with_connections_enabled?: boolean;
    has_people_to_review: boolean | null;
}
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import { useFetch } from "~vue/api";
import BaseLayout from "~vue/components/BaseLayout.vue";
import { computed } from "vue";

import Moments from "./performanceManagement/Moments.vue";
import MomentsWithConnections from "./performanceManagement/MomentsWithConnections.vue";

const props = withDefaults(defineProps<Props>(), {
    performance_review_moments: () => ({ moments: [] }),
    organization_cards: () => [],
    moments_with_connections_enabled: false,
});

const pageTabLabel = computed(() => props.performance_review_moments?.page_tab_label || "Performance Management");

const { data: uiInteractionsData, isFetching: isFetchingUIInteractions } = useFetch("/api/accounts/ui-interactions").json();

const showNadiaTeamsEvalNotification = computed(() => {
    if (isFetchingUIInteractions.value) {
        return false;
    }
    const interactions = uiInteractionsData.value?.interactions || [];
    const dismissed = interactions.some((interaction: { interaction_type?: string }) => interaction.interaction_type === "nadia_team_eval_notification_dismissed");
    return !dismissed;
});
</script>
